<template>
  <div class="refused-auth">
    <div class="auth-header">
      <img 
        src="../images/logo_font2@2x.png"
        class="header-icon"
      >
      <div class="header-home" @click="jumpHome">去主页</div>
    </div>
    <div class="auth-content">
      <div class="content-lottie">
        <vue-lottie :options="lottieOptions"></vue-lottie>
      </div>
      <div class="content-title">授信未通过</div>
      <div class="content-info">
        很遗憾，您的授信申请暂未通过<br>
        您可以于<span>{{deadTime}}</span>发起重试
      </div>
    </div>
  </div>
</template>

<script>
// 已使用授信重审卡展示
import VueLottie from 'vue-lottie'
import failData from '@/assets/json/fail.json'

export default {
  name: 'RefusedAuth',
  components: {
    VueLottie
  },
  props: {
    deadTime: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      lottieOptions: {
        animationData: failData,
        loop: false
      }
    }
  },
  methods: {
    jumpHome () {
      this.$router.push('/river/diversion')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.refused-auth{
  padding: 30px 35px;
  padding-top: 0;
  .auth-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-icon{
      width: 189px;
      height: 60px;
    }
    .header-home{
      font-size: 28px;
      color: #666666;
      text-decoration: underline;
    }
  }
  .auth-content{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 50px;
    .content-lottie{
      width: 210px;
      height: 210px;
      margin-top: 134px;
    }
    .content-title{
      font-size: 42px;
      color: #333333;
      margin-top: 30px;
      font-weight: bold;
      line-height: 59px;
    }
    .content-info{
      font-size: 26px;
      color: #666666;
      margin-top: 15px;
      line-height: 37px;
      span{
        color: #FF4633;
      }
    }
  }
}
</style>